<template>
  <v-app id="main" :style="{background: $vuetify.theme.themes[theme].background}">
    <Navbar />
    <v-main>
      <router-view/>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from '@/components/core/Navbar';
import Footer from '@/components/core/Footer';
export default {
  name: 'App',
  components: {
    Navbar,
    Footer
    },
  data: () => ({
    //
  }),
  computed:{
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
<style>
  .oswald {
    font-family: 'Oswald', sans-serif;
    font-size: 1rem;
  }
  .bordo-verde{
    border: 1px solid green;
  }
  .bordo-rosso{
    border: 1px solid red;
  }
</style>
